module.exports = "img/popups/popup_placeholder_01.gif";


//////////////////
// WEBPACK FOOTER
// ./img/popups/popup_placeholder_01.gif
// module id = 35
// module chunks = 12